import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Store } from '../types';

type ProcessedPagePathState = ReturnType<typeof getProcessedState>;

const getProcessedState = () => ({
    [MIXPANEL_EVENT_PROPERTIES.PAGE_PATH]: window.location.pathname,
});

export class PagePathStore implements Store<ProcessedPagePathState> {
    public getData = () => getProcessedState();
}
